import React from "react";

const UnassignDeviceModal = ({
  open,
  loading,
  onClose,
  onConfirm,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* backdrop */}
      <div
        className="fixed inset-0 bg-black/40 backdrop-blur-[1px]"
        onClick={onClose}
      />

      {/* modal wrapper */}
      <div className="flex min-h-full items-start justify-center p-6">
        {/* modal */}
        <div className="relative w-full max-w-2xl bg-white rounded-lg shadow-xl mt-10">
          
          {/* header */}
          <div className="flex items-center justify-between px-5 py-4 border-b">
            <h2 className="text-base font-semibold text-gray-900">
              Omron Device Reassignment Instructions
            </h2>

            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-700 text-xl leading-none"
            >
              ×
            </button>
          </div>

          {/* body (no internal scroll now) */}
          <div className="px-4 py-4 text-sm text-gray-700 text-start space-y-3">
            <ol className="list-decimal pl-5 space-y-2">
              <li>
                Login into the device/patient’s OMRON CONNECT account on a
                smartphone or tablet using the USERNAME/PASSWORD.
              </li>
              <li>Go to History → Blood Pressure.</li>
              <li>
                Look at the readings and assure the last reading on the
                device/patient’s OMRON account and the patient’s RPM page match.
              </li>
              <li>
                Delete all Patient Readings from the blood pressure monitor.
              </li>

              <div className="mt-3">
                <img
                  src="/cloud-assets/chim/public//assets/images/OmronDeviceReassignInstruction.png?id=20260215"
                  alt="instructions"
                  className="w-full rounded"
                />
              </div>

              <li>
                Go to MORE tab on OMRON Connect App → Profile → Account Settings
                → “Delete account” and press “ok” to confirm.
              </li>
              <li>
                Hit “Unassign” blood pressure device on Practice Dashboard.
              </li>
              <li className="font-semibold text-gray-900">
                This OMRON Device is now ready to be assigned to another
                patient.
              </li>
            </ol>
          </div>

          {/* footer */}
          <div className="flex justify-end gap-2 px-5 py-4 border-t">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50"
            >
              Cancel
            </button>

            <button
              disabled={loading}
              onClick={onConfirm}
              className="px-4 py-2 text-sm rounded-md bg-red-500 text-white hover:bg-red-600 disabled:opacity-50"
            >
              {loading ? "Unassigning..." : "Unassign Device"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnassignDeviceModal;
